export default __webpack_public_path__ + "static/media/LI-Logo.a95afc06.png";